import React from 'react';
import { HotelContainer } from 'containers';
import { withBookingBuilderQueryParamValidation } from 'hoc/WithQueryParamValidation';

export interface IBookingBuilderV1Props {
  match: {
    params: {
      id: string;
    };
  };
}

const BookingBuilderV1Component = (props: IBookingBuilderV1Props) => {
  return <HotelContainer id={props.match.params.id} />;
};

export const BookingBuilderV1 = withBookingBuilderQueryParamValidation(BookingBuilderV1Component);

export default BookingBuilderV1;
